import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Button,
    Input,
    Label,
    Form,
    FormGroup,
    Alert,
    FormFeedback
} from "reactstrap";
import { validationHelper, normalizeHelper } from "../../../../common/helpers";
import { messages, roles } from "../../../../common/constants";
import { getStores } from "../../../../store/store/actions";
import { createUser, resetCreatedUser, uploadUserPhoto } from "../../../../store/user/actions";
import { getRoles } from "../../../../store/role/actions";
import { getDocumentTypes } from "../../../../store/document-type/actions";
import { toast } from "react-toastify";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import { MainLoader } from "../../../../components";
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

class UserAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            photo: null
        };

        this.onSubmitUser = this.onSubmitUser.bind(this);
        this.renderStoresField = this.renderStoresField.bind(this);
        this.renderRolesField = this.renderRolesField.bind(this);
        this.renderInputFile = this.renderInputFile.bind(this);
        this.renderDocumentTypeField = this.renderDocumentTypeField.bind(this);
    }

    componentDidMount() {
        this.props.getStores();
        this.props.getRoles();
        this.props.getDocumentTypes();
    }
    componentWillUnmount() {
        this.props.resetCreatedUser();
    }
    onSubmitUser(values) {
        if (Object.entries(values).length === 0) return;
        this.props.createUser(values);
    }

    componentDidUpdate(prevProps) {
        this.checkUserCreationSuccess(prevProps);
        this.checkUploadUserPhotoSuccess(prevProps);
    }

    checkUserCreationSuccess(prevProps) {
        if (prevProps.user == null && this.props.user != null) {
            const { photo } = this.state;

            if (photo != null) {
                this.props.uploadUserPhoto(this.props.user.id, photo);
                return;
            }

            this.onSuccess();
        }
    }

    checkUploadUserPhotoSuccess(prevProps) {
        if (prevProps.uploadedPhoto == null && this.props.uploadedPhoto != null) {
            this.onSuccess();
        }

        if (prevProps.uploadPhotoError == null && this.props.uploadPhotoError != null) {
            this.onSuccess("Sin embargo, no se ha podido guardar la foto.");
        }
    }

    onSuccess(message = "") {
        let toastMessage = `Usuario creado satisfactoriamente. ${message}`;
        toast.success(toastMessage);
        this.props.history.push("/administration/users");
    }

    renderInputField(field) {
        const {
            meta: { touched, error }
        } = field;
        const hasError = touched && error ? true : false;
        const labelClass = field.labelClass ? field.labelClass : "mt-1";

        return (
            <FormGroup row>
                <Col md="2" lg="1">
                    <Label className={labelClass}>{field.label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} invalid={hasError} type={field.type} />
                    {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
                </Col>
            </FormGroup>
        );
    }

    renderStoreItems() {
        return this.props.stores.map(store => {
            return (
                <option key={store.id} value={store.id}>
                    {store.name}
                </option>
            );
        });
    }

    renderStoresField(field) {
        const {
            meta: { touched, error }
        } = field;
        const hasError = touched && error ? true : false;

        return (
            <FormGroup row>
                <Col md="2" lg="1">
                    <Label htmlFor="select">Tienda:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError}>
                        <option key={0} value={0}>
                            Seleccione...
                        </option>
                        {this.renderStoreItems()}
                    </Input>
                    {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
                </Col>
            </FormGroup>
        );
    }

    renderRoleItems() {
        return this.props.roles.map(store => {
            return (
                <option key={store.id} value={store.id}>
                    {store.name}
                </option>
            );
        });
    }

    renderRolesField(field) {
        const {
            meta: { touched, error }
        } = field;
        const hasError = touched && error ? true : false;

        return (
            <FormGroup row>
                <Col md="2" lg="1">
                    <Label htmlFor="select">Rol *:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError}>
                        <option key={0} value={0}>
                            Seleccione...
                        </option>
                        {this.renderRoleItems()}
                    </Input>
                    {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
                </Col>
            </FormGroup>
        );
    }

    renderDocumentTypeField(field) {
        const {
            meta: { touched, error }
        } = field;
        const hasError = touched && error ? true : false;

        return (
            <FormGroup row>
                <Col md="2" lg="1">
                    <Label htmlFor="select">Tipo de Documento *:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError}>
                        <option key={0} value={0}>
                            Seleccione...
                        </option>
                        {this.renderDocumentItems()}
                    </Input>
                    {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
                </Col>
            </FormGroup>
        );
    }

    renderDocumentItems() {
        return this.props.documentTypes.map(document => {
            return (
                <option key={document.id} value={document.id}>
                    {document.name}
                </option>
            );
        });
    }

    renderInputFile() {
        return (
            <FormGroup row>
                <Col md="2" lg="1">
                    <Label>Foto:</Label>
                </Col>
                <Col xs="12" md="5">
                    <FilePond
                        labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
                        acceptedFileTypes="image/jpeg, image/png"
                        labelFileTypeNotAllowed="Archivo no válido"
                        onupdatefiles={fileItems => {
                            if (fileItems.length == 0) return;
                            this.setState({ photo: fileItems[0].file });
                        }}
                        onremovefile={file => {
                            this.setState({ photo: null });
                        }}
                    />
                </Col>
            </FormGroup>
        );
    }

    renderStoreFields() {
        return (
            <div>
                <hr />
                <h5 className="mb-3">
                    <i>
                        <b>Tienda</b>
                    </i>
                </h5>
                <Field
                    name="store.name"
                    label="Nombre:"
                    type="text"
                    component={this.renderInputField}
                />
                <Field
                    name="store.address"
                    label="Dirección:"
                    type="text"
                    component={this.renderInputField}
                    normalize={normalizeHelper.noSpecialsField()}
                />
                <Field
                    name="store.ruc"
                    label="RUC Tienda:"
                    type="text"
                    component={this.renderInputField}
                    normalize={normalizeHelper.numberOnlyField(11)}
                />
                <Field
                    name="store.businessName"
                    label="Razón Social:"
                    type="text"
                    component={this.renderInputField}
                />
                <Field
                    name="store.phone"
                    label="Teléfono:"
                    type="text"
                    component={this.renderInputField}
                    normalize={normalizeHelper.numberOnlyField(9)}
                />
                <Field
                    name="store.username"
                    label="Usuario Tienda Escontech (Facturación Electrónica):"
                    type="text"
                    component={this.renderInputField}
                />
                <Field
                    name="store.password"
                    label="Contraseña Tienda Escontech (Facturación Electrónica):"
                    type="password"
                    component={this.renderInputField}
                />
                <Field
                    name="store.re_password"
                    label="Repetir Contraseña Escontech (Facturación Electrónica):"
                    type="password"
                    component={this.renderInputField}
                />
                <Field
                    name="store.url"
                    label="URL Ticket Impreso (Facturación Electrónica):"
                    type="text"
                    component={this.renderInputField}
                />
                <hr />
            </div>
        );
    }

    render() {
        const {
            handleSubmit,
            loading,
            error,
            roleIdValue,
            storesLoading,
            rolesLoading,
            uploadPhotoLoading,
            documentTypesLoading
        } = this.props;
        const isLoadingSubmit = loading || uploadPhotoLoading;
        const isLoadingFetch = storesLoading || rolesLoading || documentTypesLoading;

        if (isLoadingFetch) {
            return <MainLoader />;
        }
        return (
            <div className="animated">
                <Card>
                    <CardHeader>Nuevo Usuario</CardHeader>
                    <CardBody>
                        {error && <Alert color="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit(handleSubmit(this.onSubmitUser))}>
                            <Field
                                name="name"
                                label="Nombre *:"
                                type="text"
                                component={this.renderInputField}
                                normalize={normalizeHelper.noSpecialsField()}
                            />
                            <Field name="document_type_id" component={this.renderDocumentTypeField} />
                            <Field
                                name="dni"
                                label="N° Doc *:"
                                type="text"
                                component={this.renderInputField}
                                normalize={normalizeHelper.numberOnlyField(8)}
                            />
                            <Field
                                name="email"
                                label="Email *:"
                                type="text"
                                component={this.renderInputField}
                                normalize={normalizeHelper.emailOnlyField()}
                            />
                            <Field
                                name="phone"
                                label="Teléfono *:"
                                type="text"
                                component={this.renderInputField}
                                normalize={normalizeHelper.numberOnlyField(9)}
                            />
                            {this.renderInputFile()}
                            <Field name="role_id" component={this.renderRolesField} />
                            {roleIdValue == roles.ADMIN && <div>{this.renderStoreFields()}</div>}
                            {(roleIdValue == roles.STORE_MANAGER ||
                                roleIdValue == roles.CASHIER) && (
                                    <Field name="store_id" component={this.renderStoresField} />
                                )}
                            <Field
                                name="password"
                                label="Contraseña *:"
                                type="password"
                                component={this.renderInputField}
                            />
                            <Field
                                name="confirm_password"
                                label="Confirmar Contraseña *:"
                                labelClass="mt-0"
                                type="password"
                                component={this.renderInputField}
                            />
                            <Row>
                                <Col className="mt-3">
                                    <Button
                                        type="submit"
                                        disabled={isLoadingSubmit}
                                        color="primary"
                                        className="mr-2"
                                    >
                                        <i className="fa fa-save mr-1" /> Guardar
                                    </Button>
                                    <Button
                                        color="secondary"
                                        onClick={() =>
                                            this.props.history.push("/administration/users")
                                        }
                                    >
                                        <i className="fa fa-chevron-left mr-1" /> Cancelar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

function validate(values) {
    const errors = {};

    if (validationHelper.stringIsNullOrEmpty(values.name)) {
        errors.name = messages.MANDATORY_FIELD;
    } else if (!validationHelper.lettersOnly(values.name)) {
        errors.name = messages.LETTERS_ONLY_FIELD;
    }

    if (validationHelper.stringIsNullOrEmpty(values.document_type_id) || values.document_type_id == "0") {
        errors.document_type_id = messages.MANDATORY_FIELD;
    }

    if (
        !validationHelper.isNumber(values.dni, 8) ||
        validationHelper.stringIsNullOrEmpty(values.dni)
    ) {
        errors.dni = messages.DNI_FORMAT_FIELD;
    }

    if (validationHelper.stringIsNullOrEmpty(values.email)) {
        errors.email = messages.MANDATORY_FIELD;
    } else if (!validationHelper.isEmail(values.email)) {
        errors.email = messages.EMAIL_FORMAT_FIELD;
    }

    if (
        !validationHelper.isPhone(values.phone) ||
        validationHelper.stringIsNullOrEmpty(values.phone)
    ) {
        errors.phone = messages.PHONE_FORMAT_FIELD;
    }

    if (validationHelper.stringIsNullOrEmpty(values.role_id) || values.role_id == "0") {
        errors.role_id = messages.MANDATORY_FIELD;
    }

    if (values.role_id == roles.ADMIN) {
        const { store } = values;
        errors.store = {};

        if (!store || validationHelper.stringIsNullOrEmpty(store.name)) {
            errors.store.name = messages.MANDATORY_FIELD;
        }

        if (!store || validationHelper.stringIsNullOrEmpty(store.address)) {
            errors.store.address = messages.MANDATORY_FIELD;
        } else if (!validationHelper.noSpecialCharacters(values.address)) {
            errors.store.address = messages.LETTERS_ONLY_FIELD;
        }

        if (!store || validationHelper.stringIsNullOrEmpty(store.ruc)) {
            errors.store.ruc = messages.MANDATORY_FIELD;
        }
        if (!store || validationHelper.stringIsNullOrEmpty(store.businessName)) {
            errors.store.businessName = messages.MANDATORY_FIELD;
        }

        if (!store || validationHelper.stringIsNullOrEmpty(store.url)) {
            errors.store.url = messages.MANDATORY_FIELD;
        }

        if (!store) {
            errors.store.phone = messages.MANDATORY_FIELD;
        } else if (
            !validationHelper.isPhone(store.phone) ||
            validationHelper.stringIsNullOrEmpty(store.phone)
        ) {
            errors.store.phone = messages.PHONE_FORMAT_FIELD;
        }

        if (!store || validationHelper.stringIsNullOrEmpty(store.username)) {
            errors.store.username = messages.MANDATORY_FIELD;
        }

        if (!store || validationHelper.stringIsNullOrEmpty(store.password)) {
            errors.store.password = messages.MANDATORY_FIELD;
        }

        if (!store || validationHelper.stringIsNullOrEmpty(store.re_password)) {
            errors.store.re_password = messages.MANDATORY_FIELD;
        } else if (String(store.password).localeCompare(store.re_password) != 0) {
            errors.store.re_password = messages.NO_MATCH_PASSWORD_FIELD;
        }
    } else delete values.store;

    if (values.role_id == roles.STORE_MANAGER || values.role_id == roles.CASHIER) {
        if (validationHelper.stringIsNullOrEmpty(values.store_id) || values.store_id == "0") {
            errors.store_id = messages.MANDATORY_FIELD;
        }
    } else delete values.store_id;

    if (validationHelper.stringIsNullOrEmpty(values.password)) {
        errors.password = messages.MANDATORY_FIELD;
    }

    if (validationHelper.stringIsNullOrEmpty(values.confirm_password)) {
        errors.confirm_password = messages.MANDATORY_FIELD;
    }

    if (String(values.password).localeCompare(values.confirm_password) != 0) {
        errors.confirm_password = messages.NO_MATCH_PASSWORD_FIELD;
    }

    return errors;
}

const formSelector = formValueSelector("UserAddForm");

function mapStateToProps(state) {
    const { user, loading, error } = state.user.newUser;
    const { uploadPhoto } = state.user;
    //Todo asignar variables documentTypes y documentTypesLoading
    return {
        stores: state.store.storeList.stores,
        storesLoading: state.store.storeList.loading,
        roles: state.role.roleList.roles,
        rolesLoading: state.role.roleList.loading,

        documentTypes: state.documentType.documentTypeList.documentTypes,
        documentTypesLoading: state.documentType.documentTypeList.loading,

        user,
        loading,
        error,
        roleIdValue: formSelector(state, "role_id"),
        uploadedPhoto: uploadPhoto.photoUrl,
        uploadPhotoLoading: uploadPhoto.loading,
        uploadPhotoError: uploadPhoto.error
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getStores,
            createUser,
            getRoles,
            getDocumentTypes,
            resetCreatedUser,
            uploadUserPhoto
        },
        dispatch
    );
}

export default reduxForm({
    form: "UserAddForm",
    touchOnBlur: false,
    validate
})(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(UserAdd)
);



// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserAdd/UserAdd.js